module.exports = __webpack_public_path__ + "static/media/019-ceuta.fd1230d8.svg";